var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LensFlare',_vm._b({staticClass:"c-fallback-image",style:(_vm.aspectRatio && `--aspect-ratio: ${_vm.aspectRatio}`),attrs:{"id":_vm.$attrs.id || `fallback-image-${_vm._uid}`}},'LensFlare',_vm.variantBindings,false))
}
var staticRenderFns = []

export { render, staticRenderFns }